var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{
    'layout-default': !_vm.isMobile
  }},[_c('TopNav'),_vm._v(" "),_c('Nuxt'),_vm._v(" "),(_vm.isMobile)?_c('BottomNav'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }